export class Accounts {
    id: string;
    name: string;
  master_account_id: string;

  sub_account_expected: string;
  Classification_account: string;
  account_nature: string;
  final_account: string;
  max_credit: string;
  max_debit: string;

    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;

  showDeletedOnly: boolean;

    constructor( ) {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/accounts/accounts.ts